import React from "react";
import Select from "react-select";
import cx from "classnames";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import { withRouter } from "react-router-dom";
import qs from "query-string";

const DEFAULT_OPTIONS = [
  { value: 25, label: 25 },
  { value: 50, label: 50 },
  { value: 100, label: 100 },
];

class PaginationShow extends React.Component {
  updateValue = (value) => {
    const {
      location: { search = "", pathname },
    } = this.props;

    const query = qs.parse(search);
    // this.setState({ value: value });

    const updated = {
      ...query,
      page: 1,
      per: value.value,
    };

    this.props.history.push({
      pathname: pathname,
      search: qs.stringify(updated),
      state: {
        prevPathname: pathname,
      },
    });
  };

  render() {
    const { className, location, options = DEFAULT_OPTIONS } = this.props;
    const query = qs.parse(location.search);
    const val = query.per ? parseInt(query.per) : options[0];
    const selectedOption = options.find((o) => o.value === val);

    return (
      <Select
        className={cx(className, "wrapSelect")}
        classNamePrefix={"select"}
        defaultValue={options[0]}
        value={selectedOption}
        components={{ DropdownIndicator }}
        onChange={this.updateValue}
        options={options}
        isSearchable={false}
      />
    );
  }
}

export default withRouter(PaginationShow);
